import React from 'react'
import { connect } from 'react-redux'
import axios from '~/data/http/axios'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import PermissionChecker from '~/Classes/permissions'
import i18n from '~/i18n'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import BasicView from './basic'
import ThemesView from './themes'
import CampaignsView from './campaigns'
import BrandAnalyzerRequiredModal from '../../../../includes/brandanalyzer/brandAnalyzerRequiredModal'
import helpers from '~/Classes/helpers'
@connect((store) => {
    return { permissionStore: store.permission, accountMaster: store.accountMaster }
})
export default class TemplateDragType extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentStep: 0,
            drawer: null
        }

        this.changeStep = this.changeStep.bind(this)
        this.selectTemplate = this.selectTemplate.bind(this)
        this.selectTheme = this.selectTheme.bind(this)
    }

    changeStep(event) {
        var index
        if (event.currentTarget && event.currentTarget.id) {
            index = event.currentTarget.id
        } else if (event.currentTarget) {
            index = event.currentTarget.value
        } else {
            index = event
        }
        this.setState({
            currentStep: index
        })
    }

    selectTheme(theme) {
        var url = '/cp/templates/add/dragDrop?from=' + theme.id
        switch (theme.editorType) {
            case 1:
                url = '/cp/templates/add/fromCode?from=' + theme.id
                break
            case 2:
                url = '/cp/templates/add/wysiwyg?from=' + theme.id
                break
        }

        if (theme.brandAnalyzer) {
            if (this.props.accountMaster.accountMaster.options) {
                const brandAnalyzer = this.props.accountMaster.accountMaster.options.brandAnalyzer

                if (
                    !brandAnalyzer ||
                    !brandAnalyzer.colours ||
                    !(brandAnalyzer.fonts || brandAnalyzer.font) ||
                    !brandAnalyzer.logo
                ) {
                    this.props.dispatch(siteMaster.alterFullpage(<BrandAnalyzerRequiredModal urlOnCompletion={url} />))
                    return
                }
            }
        }
        this.props.history.push(url)
    }

    async selectTemplate(template) {
        var newTemplate = Object.assign({}, template)
        delete newTemplate.id
        delete newTemplate.CampaignId
        if (newTemplate.templateType === 4) {
            newTemplate.templateType = 1
        }

        const useEditorV2 = await helpers.getTemplateEditorVersion(this.props.accountMaster, false)

        axios.post('/template', newTemplate).then((response) => {
            newTemplate.id = response.data.Template.templateID
            if (useEditorV2.canUseV2) {
                this.props.history.push('/cp/templates/add/dragDropv2/' + response.data.Template.templateID)
            } else {
                this.props.history.push('/cp/templates/add/dragDrop/' + response.data.Template.templateID)
            }
        })
    }

    render() {
        var thisMenuOptions = [
            {
                label: 'Themes',
                value: 0
            }
        ]

        if (PermissionChecker('campaigns', this.props.permissionStore.permissions, 'write')) {
            thisMenuOptions.push({ label: 'Campaigns', value: 2 })
        }
        return (
            <div className='mar-t30'>
                <h4 className='mar-b25'>{i18n.t('templates:add.themesIndexHeader')}</h4>

                <div className='hide-sm hide-xs mar-b25'>
                    <ButtonSimple
                        className='button-simple-fullsize mar-l5'
                        selected={this.state.currentStep == 0}
                        onClick={() => {
                            this.changeStep(0)
                        }}
                    >
                        {i18n.t('templates:add.themes')}
                    </ButtonSimple>

                    {PermissionChecker('campaigns', this.props.permissionStore.permissions, 'write') && (
                        <ButtonSimple
                            className='button-simple-fullsize mar-l5'
                            selected={this.state.currentStep == 2}
                            onClick={() => {
                                this.changeStep(2)
                            }}
                        >
                            {i18n.t('templates:add.campaigns')}
                        </ButtonSimple>
                    )}
                </div>

                <div className='hide-md hide-lg mar-b25'>
                    <Select data={thisMenuOptions} onChange={this.changeStep} value={this.state.currentStep} />
                </div>

                {this.state.currentStep == 2 && <CampaignsView onSelect={this.selectTemplate} />}
                {this.state.currentStep == 0 && (
                    <ThemesView onSelect={this.selectTheme} defaultThemeGroupId={this.props.defaultThemeGroupId} />
                )}
            </div>
        )
    }
}
